import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import uploadImg from "./ReuseableImgUploadFuctions/uploadImg";
import toast from "react-hot-toast";
import { State, City } from "country-state-city";
import Select from "react-select";
import { IoIosClose, IoMdCloseCircle } from "react-icons/io";

function CheckInEdit() {
  const navigate = useNavigate();
  const [bookingData, setBookingData] = useState({});
  const [isPreBooked, setIsPreBooked] = useState(true);
  const [bookingDetails, setBookingDetails] = useState({});
  const [building, setBuilding] = useState([]);
  const [floor, setFloor] = useState([]);
  const [floorNumber, setFloorNumber] = useState(0);
  const [rooms, setRooms] = useState([]);
  const [checkInDetails, setCheckInDetails] = useState({});
  const [ProfilePic, setProfilePic] = useState("");
  const [adhaarFront, setAdhaarFront] = useState("");
  const [adhaarBack, setAdhaarBack] = useState("");
  const [terms, setTerms] = useState([]);
  const [policeVerification, setPoliceVerification] = useState([]);
  const [checkImg, setCheckImg] = useState(false);
  const [buildingId, setBuildingId] = useState("");
  const [load, setLoad] = useState(false);
  const [bed, setBed] = useState([]);
  const [currentCheckInId, setCurrentCheckInId] = useState("");
  const [focus, setFocus] = useState(false);
  const [bedFocus, setBedFocus] = useState(false);
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [selectedState, setSelectedState] = useState();

  const [searchParams] = useSearchParams();
  const id = searchParams.get("itemId");
  const floorNo = searchParams.get("floor_no");
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  //Fetch all states of India
  useEffect(() => {
    const states = State.getStatesOfCountry("IN"); //IN is the country code for India
    console.log("States: ", states);
    const formattedStates = states.map((state) => ({
      value: state?.isoCode,
      label: state?.name,
    }));

    setAllStates(formattedStates);
  }, []);

  //Setting existing state to the selectedState initially
  useEffect(() => {
    if (allStates.length > 0 && checkInDetails?.state) {
      const selectedState = allStates.find(
        (state) => state.label === checkInDetails.state
      );
      setSelectedState(selectedState || null);
    }
  }, [allStates, checkInDetails]);

  console.log("Preloaded State: ", selectedState);

  //Fetch cities when a state is selected
  useEffect(() => {
    if (selectedState) {
      console.log("Selected State: ", selectedState);
      const cities = City.getCitiesOfState("IN", selectedState?.value);
      const formattedCities = cities.map((city) => ({
        value: city?.name,
        label: city?.name,
      }));
      setAllCities(formattedCities);
    } else {
      setAllCities([]);
    }
  }, [selectedState]);

  console.log("Citis: ", allCities);

  //Get All Building Data
  const fetchAllBuildings = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("fhghgjgj---->", response.data.data);
        setBuilding(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Calling the booking details by Id
  const getFloors = (id) => {
    console.log("i am running--.", id);

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_floors_by_building/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setFloor(response.data.data.floorDetails);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Get configured room by building id and floorNumber...

  const getConfiguredRoomByBuilding = (buildingId, floorNumber) => {
    setFloorNumber(floorNumber);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/rooms/get_configured_room_by_building/${buildingId}/${floorNumber}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am floor--->", response.data);
        setRooms(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Fetch Bed by room Id...
  const handleBed = (id) => {
    const myData = {
      roomId: id,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/beds/get-beds-by-room-id`,
      headers: {
        "Content-Type": "application/json",
      },
      data: myData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("----beds array-->", response.data.data);
        setBed(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Get Checkin Data by ID
  console.log("I am check in data", checkInDetails);

  const getCheckIn = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/check_in/get_check_in/${id}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("i am response for check in--->", response.data.data);
        getFloors(response.data.data.hostelName?._id);
        handleBed(response.data.data.roomId._id);
        setCheckInDetails(response.data.data);

        setProfilePic(response.data.data.photo);
        setAdhaarBack(response.data.data.aadhaarBack);
        setAdhaarFront(response.data.data.aadhaarFront);
        setTerms(response.data.data.terms);
        setPoliceVerification(response.data.data.policeVerification);
        setCurrentCheckInId(response.data.data.hostelName?._id);
        reset({
          ...response.data.data,
          dateOfBirth: response?.data?.data?.dateOfBirth
            ? new Date(response?.data?.data?.dateOfBirth)
                .toISOString()
                .slice(0, 10)
            : null,
          joiningDate: new Date(response.data.data.joiningDate)
            .toISOString()
            .slice(0, 10),
          hostelName: response.data.data.hostelName._id,

          roomId: response.data.data.roomId._id,
          bedId: response.data.data.bedId._id,
          state: response.data.data.state,
          city: response.data.data.city,
          // city: response.data.data.city,
        });

        getConfiguredRoomByBuilding(
          response.data.data.hostelName._id,
          response.data.data.floorNo
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCheckIn();
  }, [reset]);

  useEffect(() => {
    fetchAllBuildings();
  }, []);

  //Handle Img Uploads
  const uploadHandle = async (file, type) => {
    console.log(file, type);
    setCheckImg(true);
    toast("Uploading, Please wait...", {
      icon: "👏",
      style: {
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
      },
      duration: 4000,
    });

    const imgUrl = await uploadImg(file[0]);

    if (type == "adhaarFront") {
      setAdhaarFront(imgUrl);
    } else if (type == "profile") {
      setProfilePic(imgUrl);
    } else if (type == "adhaarBack") {
      setAdhaarBack(imgUrl);
    } else if (type == "police") {
      setPoliceVerification(imgUrl);
    } else {
      setTerms(imgUrl);
    }

    setCheckImg(false);
  };

  //Handle remove image

  const removeImage = async (field, indexToRemove) => {
    if (field === policeVerification) {
      setPoliceVerification((prev) =>
        prev.filter((_, index) => index !== indexToRemove)
      );
      console.log("Index", indexToRemove);
    } else if (field === terms) {
      setTerms((prev) => prev.filter((_, index) => index !== indexToRemove));
    }
  };

  const handleFileChange = async (field, file) => {
    setCheckImg(true);
    if (checkImg) {
      toast("Uploading, Please wait...", {
        icon: "👏",
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
      });
    }

    const files = Array.from(file);

    // const newFiles = files.map(async (file) => {
    //   await uploadImg(file);
    // });

    const newFiles = await Promise.all(
      files.map(async (file) => {
        return await uploadImg(file); // Upload each file and return the URL
      })
    );

    console.log("New Files", newFiles);

    //If "policeVerification" field is modified
    if (field === policeVerification) {
      console.log("i am running");
      setPoliceVerification((prevData) => [...prevData, ...newFiles]);
      setCheckImg(false);
    }
    //If "terms" field is modified
    else if (field === terms) {
      console.log("i am running");
      setTerms((prevData) => [...prevData, ...newFiles]);
      setCheckImg(false);
    }
  };
  console.log("policeVerification: ", policeVerification);
  console.log("terms: ", terms);

  const onSubmit = async (data) => {
    console.log("Form Data Submitted: ", data);
    setLoad(true);

    const finalData = {
      ...data,
      photo: ProfilePic,
      policeVerification: policeVerification,
      state: data.state || checkInDetails?.state,
      city: data.city || checkInDetails?.city,
      terms: terms,
      aadhaarFront: adhaarFront,
      aadhaarBack: adhaarBack,
    };

    let config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/check_in/update_check_in/${id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: finalData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of EditCheckIn: ", response.data);
        toast.success(response.data.message);
        navigate("/checkin");
        setLoad(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.message);
        setLoad(false);
      });
  };

  return (
    <div className="justify-center items-center min-h-screen bg-gray-100 p-6">
      <div className="bg-white w-full p-6 rounded-lg shadow-lg">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-semibold text-primaryTextColor mb-6">
            Edit Check In
          </h2>
          <button
            onClick={() => navigate("/checkin")}
            className="rounded-md text-white bg-primaryColor hover:bg-[#0741c9] hover:scale-110 px-4 py-2 font-semibold tracking-wide transition duration-300 ease-in-out"
          >
            Go Back
          </button>
        </div>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-1 sm:grid-cols-2 gap-6"
        >
          {/* Name of the tenant */}
          <div>
            <label
              htmlFor="place-of-work"
              className="text-sm font-medium text-primaryTextColor"
            >
              Name *
            </label>
            <input
              {...register("name", {
                required: "Name is Required",
              })}
              type="text"
              placeholder="Enter Your Name"
              className={`mt-1 p-2 border ${
                errors.name ? "border-red-500" : "border-gray-300"
              } rounded w-full `}
            />
            {errors.name && (
              <span className="text-red-500 text-sm">
                {errors.name.message}
              </span>
            )}
          </div>
          {/* Aadhar Number */}
          <div className="relative">
            <label
              htmlFor="aadhaar"
              className="text-sm font-medium text-primaryTextColor"
            >
              Aadhar Number *
            </label>
            <input
              type="text"
              id="aadhaar"
              placeholder="0000 0000 0000"
              {...register("aadhaar", {
                required: "Aadhar Number is required",
                pattern: {
                  value: /^[0-9]{12}$/,
                  message: "Invalid Aadhar Number",
                },
              })}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 12);
              }}
              className={`mt-1 p-2 border ${
                errors.aadhaar ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.aadhaar && (
              <span className="text-red-500 text-sm">
                {errors.aadhaar.message}
              </span>
            )}
          </div>
          {/* Pan Number */}
          <div>
            <label
              htmlFor="pan"
              className="text-sm font-medium text-primaryTextColor"
            >
              Pan Number
            </label>
            <input
              type="text"
              id="pan"
              placeholder="ABCDE1234F"
              {...register("pan")}
              className={`mt-1 p-2 border border-gray-300 rounded w-full`}
            />
            {/* {errors.pan && (
              <span className="text-red-500 text-sm">{errors.pan.message}</span>
            )} */}
          </div>
          {/* Mobile Number */}
          <div>
            <label
              htmlFor="mobile"
              className="text-sm font-medium text-primaryTextColor"
            >
              Mobile Number *
            </label>
            <input
              type="text"
              id="mobile"
              placeholder="Enter Mobile Number"
              {...register("mobile", {
                required: "Mobile Number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Invalid Mobile Number",
                },
              })}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 10);
              }}
              className={`mt-1 p-2 border ${
                errors.mobile ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.mobile && (
              <span className="text-red-500 text-sm">
                {errors.mobile.message}
              </span>
            )}
          </div>
          {/* Email ID */}
          <div>
            <label
              htmlFor="email"
              className="text-sm font-medium text-primaryTextColor"
            >
              Email ID *
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter Email"
              {...register("email", {
                required: "Email ID is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid Email Address",
                },
              })}
              className={`mt-1 p-2 border ${
                errors.email ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.email && (
              <span className="text-red-500 text-sm">
                {errors.email.message}
              </span>
            )}
          </div>

          {/* Date of Birth  */}
          <div>
            <label
              htmlFor="dateOfBirth"
              className="text-sm font-medium text-primaryTextColor"
            >
              Date of Birth *
            </label>
            <input
              type="date"
              id="dateOfBirth"
              placeholder="Enter Date of Birth"
              {...register("dateOfBirth", {
                required: "Date of Birth ID is required",
              })}
              className={`mt-1 p-2 border ${
                errors.dateOfBirth ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.dateOfBirth && (
              <span className="text-red-500 text-sm">
                {errors.dateOfBirth.message}
              </span>
            )}
          </div>
          {/* Joining Date */}
          <div>
            <label
              htmlFor="joiningDate"
              className="text-sm font-medium text-primaryTextColor"
            >
              Joining Date *
            </label>
            <input
              type="date"
              id="joiningDate"
              {...register("joiningDate", {
                required: "Joining Date is required",
              })}
              onBlur={(e) => {
                const value = e.target.value;

                if (value) {
                  const selectedDate = new Date(value);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);

                  if (selectedDate < today) {
                    toast.error("Joining date cannot be in the past");
                    setValue(
                      "joiningDate",
                      checkInDetails.joiningDate.slice(0, 10)
                    );
                    // e.target.value = "";
                  }
                }
              }}
              className={`mt-1 p-2 border ${
                errors.joiningDate ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.joiningDate && (
              <span className="text-red-500 text-sm">
                {errors.joiningDate.message}
              </span>
            )}
          </div>
          {/* Booking Amount */}
          <div>
            <label
              htmlFor="bookingAmount"
              className="text-sm font-medium text-primaryTextColor"
            >
              Booking Amount *
            </label>
            <input
              type="number"
              id="bookingAmount"
              placeholder="₹"
              {...register("bookingAmount", {
                required: "Booking Amount is required",
                min: {
                  value: 1,
                  message: "Amount must be greater than 0",
                },
              })}
              className={`mt-1 p-2 border ${
                errors.bookingAmount ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.bookingAmount && (
              <span className="text-red-500 text-sm">
                {errors.bookingAmount.message}
              </span>
            )}
          </div>
          <div>
            <label
              htmlFor="place-of-work"
              className="text-sm font-medium text-primaryTextColor"
            >
              Place of Work *
            </label>
            <input
              type="text"
              id="place-of-work"
              placeholder="Enter Place of Work"
              {...register("placeOfWork", {
                required: false,
              })}
              className={`mt-1 p-2 border ${
                errors.placeOfWork ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.placeOfWork && (
              <span className="text-red-500 text-sm">
                {errors.placeOfWork.message}
              </span>
            )}
          </div>
          <div>
            <label
              htmlFor="sos-name"
              className="text-sm font-medium text-primaryTextColor"
            >
              SOS Person Name *
            </label>
            <input
              type="text"
              id="sos-name"
              placeholder="Enter SOS Person Name"
              {...register("sosPersonName", {
                required: "SOS Person Name is required",
              })}
              className={`mt-1 p-2 border ${
                errors.sosPersonName ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.sosPersonName && (
              <span className="text-red-500 text-sm">
                {errors.sosPersonName.message}
              </span>
            )}
          </div>
          <div>
            <label
              htmlFor="relation-sos"
              className="text-sm font-medium text-primaryTextColor"
            >
              Relation with SOS Person *
            </label>
            <input
              type="text"
              id="relation-sos"
              placeholder="Enter Relation"
              {...register("relationWithSOS", {
                required: "Relation with SOS Person is required",
              })}
              className={`mt-1 p-2 border ${
                errors.relationWithSOS ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.relationWithSOS && (
              <span className="text-red-500 text-sm">
                {errors.relationWithSOS.message}
              </span>
            )}
          </div>
          {/* SOS Contact Number */}
          <div>
            <label
              htmlFor="sos-contact"
              className="text-sm font-medium text-primaryTextColor"
            >
              SOS Contact Number *
            </label>
            <input
              type="text"
              id="sos-contact"
              placeholder="Enter SOS Contact Number"
              {...register("sosContact", {
                required: "SOS Contact Number is required",
                pattern: {
                  value: /^[6-9]\d{9}$/,
                  message:
                    "Invalid contact number. Must be 10 digits starting with 6-9",
                },
              })}
              className={`mt-1 p-2 border ${
                errors.sosContact ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 10);
              }}
            />
            {errors.sosContact && (
              <span className="text-red-500 text-sm">
                {errors.sosContact.message}
              </span>
            )}
          </div>
          {/* Home Address */}
          <div className="sm:col-span-2">
            <label
              htmlFor="address"
              className="text-sm font-medium text-primaryTextColor"
            >
              Home Address *
            </label>
            <textarea
              id="address"
              placeholder="Enter Full Address"
              {...register("homeAddress", {
                required: "Home Address is required",
              })}
              className={`mt-1 p-2 border ${
                errors.homeAddress ? "border-red-500" : "border-gray-300"
              } rounded w-full resize-none`}
            ></textarea>
            {errors.homeAddress && (
              <span className="text-red-500 text-sm">
                {errors.homeAddress.message}
              </span>
            )}
          </div>

          {/* State */}
          <div>
            <label
              htmlFor="state"
              className="text-sm font-medium text-primaryTextColor"
            >
              State *
            </label>

            <Select
              options={allStates}
              value={
                allStates.find((state) => state.label === watch("state")) ||
                null
              } // Pre-select state in edit mode
              onChange={(option) => {
                console.log("option", option);
                setSelectedState(option);
                setValue("state", option.label, { shouldValidate: true }); // Ensure validation triggers
              }}
              required
              placeholder="Select State"
              className={`border ${
                errors.state ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.state && (
              <span className="text-red-500 text-sm">
                {errors.state.message}
              </span>
            )}
          </div>

          {/* City */}
          <div>
            <label
              htmlFor="city"
              className="text-sm font-medium text-primaryTextColor"
            >
              City *
            </label>

            {/* <Select
              options={allCities}
              // value={selectedCity}
              onChange={(option) => {
                console.log("option in City: ", option);
                setValue("city", option.value);
              }}
              placeholder="Select your City"
              className={`border ${
                errors.city ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {showStateCIty && (
              <p className="text-sm text-red-500 font-medium">
                City: {checkInDetails?.city}
              </p>
            )}
            {errors.city && (
              <span className="text-red-500 text-sm">
                {errors.city.message}
              </span>
            )} */}

            <Select
              options={allCities}
              value={
                allCities.find((city) => city.label === watch("city")) || null
              } // Pre-select state in edit mode
              onChange={(option) => {
                console.log("option", option);
                setValue("city", option.label, { shouldValidate: true }); // Ensure validation triggers
              }}
              required
              placeholder="Select City"
              className={`border ${
                errors.city ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.city && (
              <span className="text-red-500 text-sm">
                {errors.city.message}
              </span>
            )}
          </div>

          <div>
            <label
              htmlFor="pincode"
              className="text-sm font-medium text-primaryTextColor"
            >
              PINCODE *
            </label>

            <input
              type="number"
              id="pincode"
              placeholder="Enter PINCODE"
              {...register("pincode", {
                required: "PIN Code is required",
                pattern: {
                  value: /^[1-9][0-9]{5}$/,
                  message: "Invalid PIN Code",
                },
              })}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 6);
              }}
              className={`mt-1 p-2 border ${
                errors.pincode ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.pincode && (
              <span className="text-red-500 text-sm">
                {errors.pincode.message}
              </span>
            )}
          </div>
          {/* Reason of Stay */}
          <div>
            <label
              htmlFor="reason-stay"
              className="text-sm font-medium text-primaryTextColor"
            >
              Reason of Stay *
            </label>
            <input
              type="text"
              id="reason-stay"
              placeholder="Enter Reason of Stay"
              {...register("reasonOfStay", {
                required: "Reason of Stay is required",
              })}
              className={`mt-1 p-2 border ${
                errors.reasonOfStay ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.reasonOfStay && (
              <span className="text-red-500 text-sm">
                {errors.reasonOfStay.message}
              </span>
            )}
          </div>

          {/* Security Deposit */}
          <div>
            <label
              htmlFor="security-deposit"
              className="text-sm font-medium text-primaryTextColor"
            >
              Security Deposit *
            </label>
            <input
              type="text"
              id="security-deposit"
              placeholder="Enter Amount (₹)"
              {...register("securityDeposit", {
                required: "Security Deposit is required",
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message:
                    "Invalid amount. Enter a valid number with up to 2 decimals",
                },
              })}
              className={`mt-1 p-2 border ${
                errors.securityDeposit ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.securityDeposit && (
              <span className="text-red-500 text-sm">
                {errors.securityDeposit.message}
              </span>
            )}
          </div>

          {/* -----------------------------------Danger Zone Start-------------------------------- */}

          {/* building name */}
          <div className="">
            <label className="block text-sm font-medium text-primaryTextColor">
              Building Name <span className="text-red-500">*</span>
            </label>
            <select
              //   value={checkInDetails?.hostelName?._id}
              {...register("hostelName", { required: true })}
              className={`mt-1 block w-full border ${
                errors.hostelName ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm p-2`}
              onChange={(e) => {
                getFloors(e.target.value);
                setBuildingId(e.target.value);
              }}
            >
              {building.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.nameBuilding}
                </option>
              ))}
            </select>
          </div>
          {/* floor no */}
          <div className="col-span-1">
            <label className="block text-sm font-medium text-primaryTextColor">
              Floor No <span className="text-red-500">*</span>
            </label>
            <select
              className={`mt-1 block w-full border ${
                errors.floorNo ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm p-2`}
              {...register("floorNo", { required: true })}
              onChange={(e) =>
                getConfiguredRoomByBuilding(currentCheckInId, e.target.value)
              }
            >
              <option value="">Select a floor</option>
              {floor.map((f, index) => (
                <option key={index} value={f.floorNumber}>
                  Floor-{f.floorNumber}
                </option>
              ))}
            </select>
          </div>

          {/* Room No  */}

          {focus ? (
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Select from Available Rooms{" "}
                <span className="text-red-500">*</span>
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.roomId ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("roomId")}
                onChange={(e) => {
                  handleBed(e.target.value);
                }}
              >
                <option value="">Select Room</option>
                {rooms.map((room, index) => (
                  <option key={index} value={room._id}>
                    R-F{room.floorNumber}
                    {String(room.roomNumber).padStart(3, "0")}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <div className="">
              <label className="block text-sm font-medium text-primaryTextColor">
                Select from Available Rooms{" "}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                onFocus={() => {
                  setFocus(true);
                }}
                value={` R-F${checkInDetails?.floorNo}${String(
                  checkInDetails?.roomId?.roomNumber
                ).padStart(3, "0")}`}
                className="mt-1 block w-full border  rounded-md shadow-sm p-2 "
              />
            </div>
          )}

          {/* Bed No */}
          {bedFocus ? (
            <div className="col-span-1">
              <label className="block text-sm font-medium text-primaryTextColor">
                Select from available Beds
                <span className="text-red-500">*</span>
              </label>
              <select
                className={`mt-1 block w-full border ${
                  errors.bedId ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm p-2`}
                {...register("bedId", { required: true })}
              >
                <option value="">Select Bed Number</option>
                {bed
                  .sort((a, b) => {
                    const numA = parseInt(a.bedNumber.slice(1)); // Extract the number after 'B'
                    const numB = parseInt(b.bedNumber.slice(1)); // Extract the number after 'B'
                    return numA - numB; // Compare the numbers
                  })
                  ?.map((bed, index) => (
                    <option
                      key={index}
                      value={bed._id}
                      disabled={bed.isOccupied}
                      style={{
                        color: bed.isOccupied ? "green" : "black",
                      }}
                    >
                      {bed.bedNumber} {bed.isOccupied && "(Occupied)"}
                    </option>
                  ))}
              </select>
            </div>
          ) : (
            <div className="">
              <label className="block text-sm font-medium text-primaryTextColor">
                Select from Available Beds{" "}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                onFocus={() => {
                  setBedFocus(true);
                }}
                value={checkInDetails?.bedId?.bedNumber}
                className="mt-1 block w-full border  rounded-md shadow-sm p-2 "
              />
            </div>
          )}

          {/* ---------------------------------Danger Zone End--------------------------------------- */}

          {/* Rent of Bed */}
          <div>
            <label
              htmlFor="bed-rent"
              className="text-sm font-medium text-primaryTextColor"
            >
              Rent of Bed *
            </label>
            <input
              type="text"
              id="bed-rent"
              placeholder="Enter Rent"
              {...register("bedRent", {
                required: "Rent of Bed is required",
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message:
                    "Invalid rent format. Enter a valid number with up to 2 decimals",
                },
              })}
              className={`mt-1 p-2 border ${
                errors.bedRent ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.bedRent && (
              <span className="text-red-500 text-sm">
                {errors.bedRent.message}
              </span>
            )}
          </div>
          {/* Photo */}
          <div>
            <label
              htmlFor="photo"
              className="text-sm font-medium text-primaryTextColor"
            >
              Photo
            </label>
            <input
              type="file"
              id="photo"
              {...register("photo")}
              onChange={(e) => {
                uploadHandle(e.target.files, "profile");
              }}
              className={`mt-1 p-2 border ${
                errors.photo ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.photo && (
              <span className="text-red-500 text-sm">
                {errors.photo.message}
              </span>
            )}
            <img
              src={ProfilePic}
              alt="No Image"
              srcset=""
              className="w-[6rem] rounded-md object-cover mt-2"
            />
          </div>
          {/* Police Verification Form */}
          <div>
            <label
              htmlFor="police-verification"
              className="text-sm font-medium text-primaryTextColor"
            >
              Police Verification Form
            </label>
            <input
              type="file"
              id="police-verification"
              accept="image/*"
              multiple
              {...register("policeVerification")}
              onChange={(e) => {
                handleFileChange(policeVerification, e.target.files);
              }}
              className={`mt-1 p-2 border ${
                errors.policeVerification ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.policeVerification && (
              <span className="text-red-500 text-sm">
                {errors.policeVerification.message}
              </span>
            )}
            <div className="flex flex-wrap gap-2">
              {policeVerification?.map((image, index) => (
                <div key={index} className="relative p-1">
                  <IoMdCloseCircle
                    className="absolute top-1 -right-1 cursor-pointer font-bold"
                    color="red"
                    size={16}
                    onClick={() => removeImage(policeVerification, index)}
                  />
                  <img
                    src={image}
                    alt="Police Verification"
                    srcset=""
                    className="w-[6rem] rounded-md object-cover mt-2"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* T&C Form */}
          <div>
            <label
              htmlFor="terms"
              className="text-sm font-medium text-primaryTextColor"
            >
              T&C Form
            </label>
            <input
              type="file"
              accept="image/*"
              multiple
              id="terms"
              {...register("terms")}
              onChange={(e) => handleFileChange(terms, e.target.files)}
              className={`mt-1 p-2 border ${
                errors.terms ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.terms && (
              <span className="text-red-500 text-sm">
                {errors.terms.message}
              </span>
            )}
            <div className="flex flex-wrap gap-2">
              {terms?.map((image, index) => (
                <div key={index} className="relative p-1">
                  <IoMdCloseCircle
                    className="absolute top-1 -right-1 cursor-pointer font-bold"
                    color="red"
                    size={16}
                    onClick={() => removeImage(terms, index)}
                  />
                  <img
                    src={image}
                    alt="No Image"
                    srcset=""
                    className="w-[6rem] rounded-md object-cover mt-2"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Aadhaar Card Front Image */}
          <div>
            <label
              htmlFor="aadhaar-front"
              className="text-sm font-medium text-primaryTextColor"
            >
              Aadhaar Card Front Image *
            </label>
            <input
              type="file"
              id="aadhaar-front"
              {...register("aadhaarFront")}
              onChange={(e) => {
                uploadHandle(e.target.files, "adhaarFront");
              }}
              className={`mt-1 p-2 border ${
                errors.aadhaarFront ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.aadhaarFront && (
              <span className="text-red-500 text-sm">
                {errors.aadhaarFront.message}
              </span>
            )}
            <img
              src={adhaarFront}
              alt="No Image"
              srcset=""
              className="w-[6rem] rounded-md object-cover mt-2"
            />
          </div>
          {/* Aadhaar Card Back Image */}
          <div>
            <label
              htmlFor="aadhaar-back"
              className="text-sm font-medium text-primaryTextColor"
            >
              Aadhaar Card Back Image *
            </label>
            <input
              type="file"
              id="aadhaar-back"
              {...register("aadhaarBack")}
              onChange={(e) => {
                uploadHandle(e.target.files, "adhaarBack");
              }}
              className={`mt-1 p-2 border ${
                errors.aadhaarBack ? "border-red-500" : "border-gray-300"
              } rounded w-full`}
            />
            {errors.aadhaarBack && (
              <span className="text-red-500 text-sm">
                {errors.aadhaarBack.message}
              </span>
            )}
            <img
              src={adhaarBack}
              alt="No Image"
              srcset=""
              className="w-[6rem] rounded-md object-cover mt-2"
            />
          </div>
          {/* Other Fields */}
          {/* Repeat similar blocks for all fields such as `placeOfWork`, `sosName`, `relationSos`, `address`, etc., ensuring they include proper validation rules. */}
          {/* Submit and Cancel Buttons */}
          <div className="flex justify-between sm:col-span-2 mt-4 gap-5">
            <button
              type="button"
              onClick={() => navigate("/checkin")}
              className="bg-gray-100 hover:bg-gray-300 text-primaryTextColor px-4 py-2 rounded w-[50%]"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-primaryBtnColor hover:bg-primaryBtnHoverColor text-white px-4 py-2 rounded w-[50%]"
            >
              {"Submit"}
            </button>
          </div>
        </form>
      </div>
      {load && (
        <div className="fixed inset-0 h-screen w-screen flex items-center justify-center bg-black bg-opacity-50">
          <span class="loader"></span>
        </div>
      )}
    </div>
  );
}

export default CheckInEdit;

// -------------------------------------
// explore purposes

// , {
//     required: "Aadhaar Card Back Image is required",
//     validate: {
//       acceptedFormats: (files) =>
//         files[0]?.type === "image/jpeg" ||
//         files[0]?.type === "image/png"
//           ? true
//           : "Only JPEG or PNG formats are allowed",
//       fileSize: (files) =>
//         files[0]?.size <= 2 * 1024 * 1024 ||
//         "File size must be less than 2MB",
//     },
//   }
